import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default  new Vuex.Store({
  state:{
    menuFirstIndex: 0,
    menuSecondIndex: 0
  },
  mutations:{
    setMenuFirstIndex(state, index){
      state.menuFirstIndex = index;
    },
    setMenuSecondIndex(state, index){
      state.menuSecondIndex = index;
    }
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js